import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import AdminPage from "./Admin/Admin";
import { lazy, Suspense } from "react";
import Loader from "./Admin/AdminUtils/Loader";
import AdminDashboard from "./Admin/Dashboard/Dashboard";
import AdminLogin from "./Admin/Login/Login";
import ErrorElementAdm from "./Admin/Error/Error";
import "./App.scss";

const Messages = lazy(() => import("./Admin/Messages/Messages"));
const AdminSettingsPage = lazy(() => import("./Admin/Settings/Settings"));
const AdminAddService = lazy(() =>
  import("./Admin/Settings/AdminAddService/AdminAddService")
);
const AddAdmin = lazy(() => import("./Admin/Settings/AddAdmin/AddAdmin"));

const AdminReviewPosts = lazy(() =>
  import("./Admin/AdminReviewPosts/AdminReviewPosts")
);

function App() {
  const routes = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="/"
          errorElement={<ErrorElementAdm />}
          element={<Suspense fallback={<Loader />}>{<AdminPage />}</Suspense>}
        >
          <Route
            index
            element={
              <Suspense fallback={<Loader />}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path="admin/posts"
            element={
              <Suspense fallback={<Loader />}>
                <AdminReviewPosts />
              </Suspense>
            }
          />
          <Route
            path="admin/messages"
            element={
              <Suspense fallback={<Loader />}>
                <Messages />
              </Suspense>
            }
          />
          <Route path="admin/add-user" element={<AddAdmin />} />
          <Route
            path="admin/settings"
            element={
              <Suspense fallback={<Loader />}>
                <AdminSettingsPage />
              </Suspense>
            }
          />
          <Route
            path="admin/add-services"
            element={
              <Suspense fallback={<Loader />}>
                <AdminAddService />
              </Suspense>
            }
            errorElement={<ErrorElementAdm />}
          />
        </Route>
        <Route
          path="/admin/login"
          element={
            <Suspense fallback={<Loader />}>
              <AdminLogin />
            </Suspense>
          }
          errorElement={<ErrorElementAdm />}
        />
      </>
    )
  );

  return <RouterProvider router={routes} />;
}

export default App;
